import React, { useEffect, useState } from 'react';

import SecondaryNavBar from '../../../Components/SecondaryNavBar/SecondaryNavBar';

import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { useSelector } from "react-redux";
import { validationNir } from "../../../api/gestionService";
import { getLabelInput } from "../../../utils/stringUtils";
import {
    checkInvalidDateEffet,
    checkInvalidNom, getBooleanValue,
    isFifteenDigits,
    renderError,
    upperCaseRemoveAccent
} from "../../../utils/formUtils";
import DOMPurify from "dompurify";
import moment from "moment";
import { changementNom, postNouveauxAyantsDroit } from "../../../api/envoiMailService";
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";

export default function AjoutAyantDroits(
    {
        isInside
    }
) {

    /**
     * TODO à faire
     * Contrôle dateEffet
     * Contrôles submit
     * Object d'envoi
     */

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const CONF = window?.confPub;
    const PATTERNS = CONF?.PATTERNS
    const UI_AJOUT_AD = CONF?.UI?.FORMULAIRES?.AJOUT_AYANTS_DROIT
    const TYPE_INDIVIDU = CONF?.TYPE_INDIVIDU
    const CIVILITE = CONF?.CIVILITE

    const newAyantDroit = () => {

        return {
            [UI_AJOUT_AD?.TYPE?.NAME]: {
                name: UI_AJOUT_AD?.TYPE?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.TYPE?.ERRORS?.MANDATORY,
            },
            [UI_AJOUT_AD?.CIVILITE?.NAME]: {
                name: UI_AJOUT_AD?.CIVILITE?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.CIVILITE?.ERRORS?.MANDATORY,
            },
            [UI_AJOUT_AD?.PRENOM?.NAME]: {
                name: UI_AJOUT_AD?.PRENOM?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.PRENOM?.ERRORS?.MANDATORY,
            },
            [UI_AJOUT_AD?.NOM?.NAME]: {
                name: UI_AJOUT_AD?.NOM?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.NOM?.ERRORS?.MANDATORY,
            },
            [UI_AJOUT_AD?.DATE_NAISSANCE?.NAME]: {
                name: UI_AJOUT_AD?.DATE_NAISSANCE?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.DATE_NAISSANCE?.ERRORS?.MANDATORY,
            },

            [UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME]: {
                name: UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.ERRORS?.MANDATORY,
            },
            [UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME]: {
                name: UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.ERRORS?.MANDATORY,
            },
            [UI_AJOUT_AD?.CODE_CAISSE?.NAME]: {
                name: UI_AJOUT_AD?.CODE_CAISSE?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.CODE_CAISSE?.ERRORS?.MANDATORY,
            },
            [UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME]: {
                name: UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME,
                value: "",
                invalid: null,
            },
            [UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME]: {
                name: UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME,
                value: "",
                invalid: null,
            },
            [UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME]: {
                name: UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME,
                value: "",
                invalid: UI_AJOUT_AD?.CARTE_INVALIDITE?.ERRORS?.MANDATORY,
            },
        }
    }

    const [dateEffet, setDateEffet] = useState({
        name: UI_AJOUT_AD?.DATE_EFFET?.NAME,
        value: "",
        invalid: UI_AJOUT_AD?.DATE_EFFET?.ERRORS?.MANDATORY,
    })

    const [disabledForm, setDisabledForm] = useState(false);
    const [submitted, setSubmitted] = useState(false)
    const [sendSuccess, setSendSuccess] = useState({
        isSuccess: false,
        message: false,
        display: false,
    })
    const [nouveauxAyantsDroit, setNouveauxAyantsDroit] = useState([
        newAyantDroit(),
    ])

    const checkInput = (name, value) => {

        const trimValue = typeof value === "string" ? value?.trim() : value
        let invalid = null

        switch (name) {

        case UI_AJOUT_AD?.DATE_EFFET?.NAME:

            invalid = checkInvalidDateEffet(value)

            break

        case UI_AJOUT_AD?.TYPE?.NAME:

            if (!value) {
                invalid = UI_AJOUT_AD?.TYPE?.ERRORS?.MANDATORY
            }
            break

        case UI_AJOUT_AD?.CIVILITE?.NAME:

            if (!value) {
                invalid = UI_AJOUT_AD?.TYPE?.ERRORS?.MANDATORY
            }
            break

        case UI_AJOUT_AD?.PRENOM?.NAME:

            invalid = checkInvalidNom(value, UI_AJOUT_AD?.PRENOM?.NAME)
            break

        case UI_AJOUT_AD?.NOM?.NAME:

            invalid = checkInvalidNom(value, UI_AJOUT_AD?.NOM?.NAME)
            break

        case UI_AJOUT_AD?.DATE_NAISSANCE?.NAME:

            if (!value) {

                invalid = UI_AJOUT_AD?.DATE_NAISSANCE?.ERRORS?.MANDATORY
            }
            break

        case UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME:

            if (!trimValue) {

                invalid = UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.ERRORS?.MANDATORY
            } else if (!isFifteenDigits(trimValue)) {

                invalid = UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.ERRORS?.INVALID
            }
            break

        case UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME:

            if (!trimValue) {

                invalid = UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.ERRORS?.MANDATORY
            }
            break

        case UI_AJOUT_AD?.CODE_CAISSE?.NAME:

            if (!trimValue) {

                invalid = UI_AJOUT_AD?.CODE_CAISSE?.ERRORS?.MANDATORY
            }
            break

        case UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME:

            // TODO vérifier si pas nombre
            // if (trimeValue) {
            //
            //     invalid = UI_AJOUT_AD?.DATE_NAISSANCE?.ERRORS?.MANDATORY
            // }
            break

        default:

            break
        }

        return invalid
    }

    const handleInput = async (e, index, nameIn) => {

        const { name, value, type, checked, files } = e?.target

        const updateName = nameIn ?? name

        console.log("name")
        console.log(name)

        const updateValue = type === "text" ? upperCaseRemoveAccent(value) : value

        let invalid = checkInput(updateName, updateValue)

        if (UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME === name) {

            const validationNirReturn = await validationNir(updateValue)

            if (validationNirReturn?.code === "NIR_INVALID_KEY") {
                invalid = validationNirReturn?.message
            }
        }

        if (type === "file") {

            invalid = files?.length > 0 ? false : "Document obligatoire."
        }

        const newList = [...nouveauxAyantsDroit]

        newList[index] = {
            ...newList?.[index],
            [updateName]: {
                ...newList?.[index]?.[updateName],
                value: type === "checkbox" ? checked : type === "file" ? files?.[0] : updateValue,
                invalid: invalid,
            }
        }

        setNouveauxAyantsDroit(newList)
    }

    const handleDateEffet = (e) => {

        const { name, value, type, checked } = e?.target

        const invalid = checkInput(name, value)

        setDateEffet((prev) =>({
            ...prev,
            invalid: invalid,
            value: value,
        }))
    }

    const checkNewAyantsDroit = async (newAyantsDroit) => {

        let invalidAyantsDroit = false

        // FIXME vérifier les message erreur en fonction des champs
        // Promise.all attend que toutes les promesses soient résolue
        const updatedNewAyantsDroit = await Promise.all(
            newAyantsDroit.map(async (nouvelAyantDroit) => {
                const updatedAyantDroit = {};

                for (const [key, field] of Object.entries(nouvelAyantDroit)) {

                    let invalid = checkInput(field?.name, field?.value)

                    if (UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME === field?.name) {

                        const validationNirReturn = await validationNir(field?.value)

                        if (validationNirReturn?.code === "NIR_INVALID_KEY") {
                            invalid = validationNirReturn?.message
                        }
                    }

                    if (nouvelAyantDroit?.[UI_AJOUT_AD?.TYPE?.NAME]?.value === CONF?.TYPE_INDIVIDU?.ENF?.CODE
                        && nouvelAyantDroit?.[UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME]?.value && field?.name === UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME
                        && !nouvelAyantDroit?.[UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME]?.value) {

                        invalid = UI_AJOUT_AD?.CARTE_INVALIDITE?.ERRORS?.MANDATORY
                    }

                    if (invalid) {
                        invalidAyantsDroit = true
                    }

                    updatedAyantDroit[key] = {
                        ...field,
                        invalid: invalid,
                    }
                }
                return updatedAyantDroit
            })
        );

        return { invalidAyantsDroit, updatedNewAyantsDroit }
    }

    const checkFormulaire = async () => {

        const invalidDateEffet = checkInput(UI_AJOUT_AD?.DATE_EFFET?.NAME, dateEffet?.value)

        setDateEffet((prev) => ({
            ...prev,
            invalid: invalidDateEffet,
        }))

        const { invalidAyantsDroit, updatedNewAyantsDroit } = await checkNewAyantsDroit(nouveauxAyantsDroit)

        setNouveauxAyantsDroit(updatedNewAyantsDroit)

        return invalidAyantsDroit || invalidDateEffet
    }

    const formatValue = (name, value) => {

        let valueUpdated = value

        switch (name) {

        case UI_AJOUT_AD?.DATE_NAISSANCE?.NAME:

            valueUpdated = moment(value, PATTERNS?.YYYY_DASH_MM_DASH_DD).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY)
            break

        case UI_AJOUT_AD?.TYPE?.NAME:

            valueUpdated = TYPE_INDIVIDU?.[value]?.LABEL ?? value
            break

        case UI_AJOUT_AD?.CIVILITE?.NAME:

            valueUpdated = CIVILITE?.[value]?.LABEL ?? value
            break

        case UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME:

            valueUpdated = value ? "oui" : "non"
            break
        }

        return valueUpdated
    }

    const buildAyantsToSend = (newAyantsDroit) => {

        return newAyantsDroit
            .map((ayantDroit) => {
                return Object.values(ayantDroit)
                    .map((input) => {
                        const label = Object.values(UI_AJOUT_AD)?.find(({ NAME }) => NAME === input?.name)?.LABEL
                        const value = formatValue(input?.name, input.value)

                        // TODO modifier les value pour que ça soit propre
                        return input?.value && label && input?.name !== UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME
                            ? `${ label } : ${ value }` : null
                    })
                    .filter(Boolean)
                    .join(`,\n\n `)
            })
            .join(`\n\n `)
    }

    const handleSubmit = async (e) => {

        e?.preventDefault()
        setDisabledForm(true)

        const invalidFormulaire = await checkFormulaire()

        if (!invalidFormulaire) {

            const newAyantsDroitPrepared = buildAyantsToSend(nouveauxAyantsDroit)
            const dateEffetPrepared = moment(dateEffet?.value, PATTERNS?.YYYY_DASH_MM_DASH_DD).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY)

            console.log("newAyantsDroitPrepared")
            console.log(newAyantsDroitPrepared)

            const files = []

            nouveauxAyantsDroit?.forEach((nouvelAyantDroit) => {

                if (nouvelAyantDroit?.[UI_AJOUT_AD?.TYPE?.NAME]?.value === CONF?.TYPE_INDIVIDU?.ENF?.CODE
                    && nouvelAyantDroit?.[UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME]?.value
                    && nouvelAyantDroit?.[UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME]?.value) {

                    const originalFile = [nouvelAyantDroit?.[UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME]?.value]
                    const originalFileName = originalFile?.[0]?.name

                    console.log("originalFile")
                    console.log(originalFile)

                    console.log("originalFileName")
                    console.log(originalFileName)
                    const extension = originalFileName.substring(originalFileName.lastIndexOf("."));
                    const newFileName = `Carte invalidité ${ nouvelAyantDroit?.[UI_AJOUT_AD?.PRENOM?.NAME]?.value } ${ nouvelAyantDroit?.[UI_AJOUT_AD?.NOM?.NAME]?.value }${ extension }`

                    const renamedFile = new File([originalFile?.[0]], newFileName, {
                        type: originalFile?.[0].type,
                        lastModified: originalFile?.[0].lastModified
                    });

                    console.log("renamedFile")
                    console.log(renamedFile)

                    // files.push(nouvelAyantDroit?.[UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME]?.value)
                    files.push(renamedFile)
                }
            })

            try {

                const resp = await postNouveauxAyantsDroit(keycloakReduce?.decodedToken?.email,
                    detailPersonne, dateEffetPrepared, newAyantsDroitPrepared, files)

                setSendSuccess({
                    isSuccess: true,
                    message: false,
                    display: true,
                })

            } catch (err) {

                setSendSuccess({
                    isSuccess: false,
                    message: false,
                    display: true,
                })

                setDisabledForm(false)
                setSubmitted(true)

            } finally {

                setDisabledForm(false)
            }

        } else {

            setDisabledForm(false)
            setSubmitted(true)
        }
    }

    const addAyantDroit = () => {

        const nouveauxAyantsDroitUpdated = [
            ...nouveauxAyantsDroit,
            newAyantDroit(),
        ]

        setNouveauxAyantsDroit(nouveauxAyantsDroitUpdated)
    }

    const removeAyantDroit = (indexIn) => {

        const nouveauxAyantsDroitUpdated = nouveauxAyantsDroit.filter((_, index) => index !== indexIn)

        setNouveauxAyantsDroit(nouveauxAyantsDroitUpdated)
    }

    const erasedInputs = (all) => {

        setSubmitted(false)

        if (all) {

            setSendSuccess({
                isSuccess: false,
                message: false,
                display: false,
            })
        }
    }

    return (
        <div className="container mt-3">
            { !isInside && <SecondaryNavBar /> }
            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ `${ !isInside ? 'col-lg-8' : '' }` }>
                    <div className="card">

                        <form onSubmit={ handleSubmit }>
                            <div className="card-header">
                                <h2>Ajout d'ayant droit</h2>
                            </div>

                            <div className="card-body">

                                <div className="row justify-content-between">

                                    <div className="col-lg-4">
                                        <label
                                            htmlFor={ UI_AJOUT_AD?.DATE_EFFET?.NAME }>
                                            { UI_AJOUT_AD?.DATE_EFFET?.LABEL }
                                        </label>
                                        <input
                                            id={ UI_AJOUT_AD?.DATE_EFFET?.NAME }
                                            className="form-control"
                                            value={ dateEffet?.value }
                                            onChange={ handleDateEffet }
                                            type="date"/>


                                        { submitted && dateEffet?.invalid
                                            && renderError(dateEffet?.invalid) }
                                    </div>

                                    <div className="col-lg-4 d-flex justify-content-end align-items-end">
                                        <button
                                            type='button'
                                            className="btn btn-secondary"
                                            onClick={ () => addAyantDroit() }
                                        >
                                            Ajouter un ayant droit
                                        </button>
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    { nouveauxAyantsDroit?.length > 0 && nouveauxAyantsDroit?.map((nouvelAyantDroit, index) => {

                                        return (
                                            <div className={ `${ nouveauxAyantsDroit?.length > 1 ? "col-lg-6" : "" } ${ index > 1 ? "mt-3" : "" }` }
                                                 key={ `ayant-droit-${ index }` }>
                                                <div className="card h-100">
                                                    <div className="card-header">
                                                        Nouvel ayant droit
                                                    </div>
                                                    <div className="card-body">

                                                        <div className="row">

                                                            <div
                                                                className={ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }>
                                                                <div className={ 'form-label' }>
                                                                    <span>{ getLabelInput(UI_AJOUT_AD?.TYPE) }</span>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name={ `${ UI_AJOUT_AD?.TYPE?.NAME }-${ index }` }
                                                                        id={ `${ UI_AJOUT_AD?.TYPE?.OPTIONS?.CONJOINT?.ID }-${ index }` }
                                                                        checked={ nouvelAyantDroit?.[UI_AJOUT_AD?.TYPE?.NAME]?.value === UI_AJOUT_AD?.TYPE?.OPTIONS?.CONJOINT?.VALUE }
                                                                        onChange={ (e) => handleInput(e, index, UI_AJOUT_AD?.TYPE?.NAME) }
                                                                        value={ UI_AJOUT_AD?.TYPE?.OPTIONS?.CONJOINT?.VALUE }
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={ UI_AJOUT_AD?.TYPE?.OPTIONS?.CONJOINT?.ID }>
                                                                        { UI_AJOUT_AD?.TYPE?.OPTIONS?.CONJOINT?.LABEL }
                                                                    </label>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name={ `${ UI_AJOUT_AD?.TYPE?.NAME }-${ index }` }
                                                                        id={ `${ UI_AJOUT_AD?.TYPE?.OPTIONS?.ENFANT?.ID }-${ index }` }
                                                                        checked={ nouvelAyantDroit?.[UI_AJOUT_AD?.TYPE?.NAME]?.value === UI_AJOUT_AD?.TYPE?.OPTIONS?.ENFANT?.VALUE }
                                                                        onChange={ (e) => handleInput(e, index, UI_AJOUT_AD?.TYPE?.NAME) }
                                                                        value={ UI_AJOUT_AD?.TYPE?.OPTIONS?.ENFANT?.VALUE }
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={ UI_AJOUT_AD?.TYPE?.OPTIONS?.ENFANT?.ID }>
                                                                        { UI_AJOUT_AD?.TYPE?.OPTIONS?.ENFANT?.LABEL }
                                                                    </label>
                                                                </div>

                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.TYPE?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.TYPE?.NAME]?.invalid) }
                                                            </div>

                                                            <div
                                                                className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                <div className={ 'form-label' }>
                                                                    <span>{ getLabelInput(UI_AJOUT_AD?.CIVILITE) }</span>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name={ `${ UI_AJOUT_AD?.CIVILITE?.NAME }-${ index }` }
                                                                        id={ `${ UI_AJOUT_AD?.CIVILITE?.OPTIONS?.M?.ID }-${ index }` }
                                                                        checked={ nouvelAyantDroit?.[UI_AJOUT_AD?.CIVILITE?.NAME]?.value === UI_AJOUT_AD?.CIVILITE?.OPTIONS?.M?.VALUE }
                                                                        onChange={ (e) => handleInput(e, index, UI_AJOUT_AD?.CIVILITE?.NAME) }
                                                                        value={ UI_AJOUT_AD?.CIVILITE?.OPTIONS?.M?.VALUE }
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={ UI_AJOUT_AD?.CIVILITE?.OPTIONS?.M?.ID }>
                                                                        { UI_AJOUT_AD?.CIVILITE?.OPTIONS?.M?.LABEL }
                                                                    </label>
                                                                </div>

                                                                <div className="form-check form-check-inline">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name={ `${ UI_AJOUT_AD?.CIVILITE?.NAME }-${ index }` }
                                                                        id={ `${ UI_AJOUT_AD?.CIVILITE?.OPTIONS?.MME?.ID }-${ index }` }
                                                                        checked={ nouvelAyantDroit?.[UI_AJOUT_AD?.CIVILITE?.NAME]?.value === UI_AJOUT_AD?.CIVILITE?.OPTIONS?.MME?.VALUE }
                                                                        onChange={ (e) => handleInput(e, index, UI_AJOUT_AD?.CIVILITE?.NAME) }
                                                                        value={ UI_AJOUT_AD?.CIVILITE?.OPTIONS?.MME?.VALUE }
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={ UI_AJOUT_AD?.CIVILITE?.OPTIONS?.MME?.ID }>
                                                                        { UI_AJOUT_AD?.CIVILITE?.OPTIONS?.MME?.LABEL }
                                                                    </label>
                                                                </div>

                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.CIVILITE?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.CIVILITE?.NAME]?.invalid) }
                                                            </div>

                                                            <div className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                <label htmlFor={ UI_AJOUT_AD?.NOM?.NAME }
                                                                       className={ 'form-label' }>
                                                                    { getLabelInput(UI_AJOUT_AD?.NOM) }
                                                                </label>
                                                                <input
                                                                    id={ `${ UI_AJOUT_AD?.NOM?.NAME }-${ index }` }
                                                                    name={ UI_AJOUT_AD?.NOM?.NAME }
                                                                    className="form-control"
                                                                    value={ nouvelAyantDroit?.[UI_AJOUT_AD?.NOM?.NAME]?.value }
                                                                    onChange={ (e) => handleInput(e, index) }
                                                                    placeholder={ UI_AJOUT_AD?.NOM?.PLACEHOLDER }
                                                                    type="text"/>
                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.NOM?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.NOM?.NAME]?.invalid) }
                                                            </div>
                                                            <div className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                <label htmlFor={ UI_AJOUT_AD?.PRENOM?.NAME }
                                                                       className={ 'form-label' }>
                                                                    { getLabelInput(UI_AJOUT_AD?.PRENOM) }
                                                                </label>
                                                                <input
                                                                    id={ `${ UI_AJOUT_AD?.PRENOM?.NAME }-${ index }` }
                                                                    name={ UI_AJOUT_AD?.PRENOM?.NAME }
                                                                    className="form-control"
                                                                    value={ nouvelAyantDroit?.[UI_AJOUT_AD?.PRENOM?.NAME]?.value }
                                                                    onChange={ (e) => handleInput(e, index) }
                                                                    placeholder={ UI_AJOUT_AD?.PRENOM?.PLACEHOLDER }
                                                                    type="text"/>

                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.PRENOM?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.PRENOM?.NAME]?.invalid) }
                                                            </div>

                                                            <div className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                <label
                                                                    htmlFor={ UI_AJOUT_AD?.DATE_NAISSANCE?.NAME }
                                                                    className='form-label'
                                                                    dangerouslySetInnerHTML={ {
                                                                        __html: DOMPurify.sanitize(UI_AJOUT_AD?.DATE_NAISSANCE?.LABEL)
                                                                    } }/>
                                                                <input
                                                                    name={ UI_AJOUT_AD?.DATE_NAISSANCE?.NAME }
                                                                    id={ `${ UI_AJOUT_AD?.DATE_NAISSANCE?.NAME }-${ index }` }
                                                                    className={ 'form-control' }
                                                                    // className={ `form-control ${ wasSubmit &&
                                                                    // !personne?.dateNaissance?.valid && 'is-invalid' }` }
                                                                    onChange={ (e) => handleInput(e, index) }
                                                                    value={ nouvelAyantDroit?.[UI_AJOUT_AD?.DATE_NAISSANCE?.NAME]?.value }
                                                                    type="date"/>

                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.DATE_NAISSANCE?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.DATE_NAISSANCE?.NAME]?.invalid) }
                                                            </div>

                                                            <div className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                <label
                                                                    htmlFor={ UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME }>
                                                                    { getLabelInput(UI_AJOUT_AD?.NUM_SECURITE_SOCIALE) }
                                                                </label>
                                                                <input
                                                                    id={ `${ UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME }-${ index }` }
                                                                    name={ UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME }
                                                                    className="form-control"
                                                                    value={ nouvelAyantDroit?.[UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME]?.value }
                                                                    onChange={ (e) => handleInput(e, index) }
                                                                    placeholder={ UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.PLACEHOLDER }
                                                                    type="text"/>
                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.NUM_SECURITE_SOCIALE?.NAME]?.invalid) }
                                                            </div>

                                                            <div className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                <label
                                                                    htmlFor={ UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME }>
                                                                    { getLabelInput(UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION) }
                                                                </label>
                                                                <input
                                                                    id={ `${ UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME }-${ index }` }
                                                                    name={ UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME }
                                                                    className="form-control"
                                                                    value={ nouvelAyantDroit?.[UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME]?.value }
                                                                    onChange={ (e) => handleInput(e, index) }
                                                                    placeholder={ UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.PLACEHOLDER }
                                                                    type="text"/>
                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.NOM_CAISSE_AFFILIATION?.NAME]?.invalid) }
                                                            </div>

                                                            <div className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                <label
                                                                    htmlFor={ UI_AJOUT_AD?.CODE_CAISSE?.NAME }>
                                                                    { getLabelInput(UI_AJOUT_AD?.CODE_CAISSE) }
                                                                </label>
                                                                <input
                                                                    id={ `${ UI_AJOUT_AD?.CODE_CAISSE?.NAME }-${ index }` }
                                                                    name={ UI_AJOUT_AD?.CODE_CAISSE?.NAME }
                                                                    className="form-control"
                                                                    value={ nouvelAyantDroit?.[UI_AJOUT_AD?.CODE_CAISSE?.NAME]?.value }
                                                                    onChange={ (e) => handleInput(e, index) }
                                                                    placeholder={ UI_AJOUT_AD?.CODE_CAISSE?.PLACEHOLDER }
                                                                    type="text"/>
                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.CODE_CAISSE?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.CODE_CAISSE?.NAME]?.invalid) }
                                                            </div>

                                                            <div className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                <label
                                                                    htmlFor={ UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME }>
                                                                    { getLabelInput(UI_AJOUT_AD?.RANG_GEMELLAIRE) }
                                                                </label>
                                                                <input
                                                                    id={ `${ UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME }-${ index }` }
                                                                    name={ UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME }
                                                                    className="form-control"
                                                                    value={ nouvelAyantDroit?.[UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME]?.value }
                                                                    onChange={ (e) => handleInput(e, index) }
                                                                    placeholder={ UI_AJOUT_AD?.RANG_GEMELLAIRE?.PLACEHOLDER }
                                                                    type="text"/>
                                                                { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME]?.invalid
                                                                    && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.RANG_GEMELLAIRE?.NAME]?.invalid) }
                                                            </div>

                                                            { nouvelAyantDroit?.[UI_AJOUT_AD?.TYPE?.NAME]?.value === UI_AJOUT_AD?.TYPE?.OPTIONS?.ENFANT?.VALUE && (
                                                                <>
                                                                    <div
                                                                        className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                        <div className="form-label">
                                                                            Cocher si concerné :
                                                                        </div>
                                                                        <input
                                                                            type="checkbox"
                                                                            name={ UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME }
                                                                            id={ UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME }
                                                                            onChange={ (e) => handleInput(e, index) }
                                                                            className="form-check-input"
                                                                            // checked={ formulaireIndemnisation?.[item?.NAME]?.value || "" }
                                                                            // disabled={ isComplement }
                                                                        />
                                                                        <label
                                                                            className="form-check-label ms-2"
                                                                            htmlFor={ UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME }>
                                                                            { UI_AJOUT_AD?.ENFANT_HANDICAPE?.LABEL }
                                                                        </label>
                                                                    </div>

                                                                    { nouvelAyantDroit?.[UI_AJOUT_AD?.ENFANT_HANDICAPE?.NAME]?.value && (
                                                                        <div
                                                                            className={ `mt-2 ${ nouveauxAyantsDroit?.length > 1 ? "" : "col-lg-6" }` }>
                                                                            <label
                                                                                htmlFor={ UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME }
                                                                                className="form-label">
                                                                                { getLabelInput(UI_AJOUT_AD?.CARTE_INVALIDITE) }
                                                                            </label>
                                                                            <br/>
                                                                            <input
                                                                                type="file"
                                                                                name={ UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME }
                                                                                id={ UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME }
                                                                                className="form-control"
                                                                                onChange={ (e) => handleInput(e, index) }
                                                                            />

                                                                            { submitted && nouvelAyantDroit?.[UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME]?.invalid
                                                                                && renderError(nouvelAyantDroit?.[UI_AJOUT_AD?.CARTE_INVALIDITE?.NAME]?.invalid) }
                                                                        </div>
                                                                    ) }
                                                                </>
                                                            ) }
                                                        </div>

                                                    </div>

                                                    { nouveauxAyantsDroit?.length > 1 && (
                                                        <div className="card-footer">
                                                            <button
                                                                type='button'
                                                                className="btn btn-secondary"
                                                                onClick={ () => removeAyantDroit(index) }
                                                            >
                                                                Enlever
                                                            </button>
                                                        </div>
                                                    ) }
                                                </div>
                                            </div>
                                        )
                                    }) }
                                </div>


                                <MessageInfoEnvoi
                                    isSuccess={ sendSuccess?.isSuccess }
                                    message={ sendSuccess?.message }
                                    display={ sendSuccess?.display }
                                />

                            </div>

                            <div className="card-footer">
                                <div className='d-flex justify-content-end'>
                                    <button
                                        type='submit'
                                        className="btn btn-primary"
                                    >
                                        Envoyer
                                    </button>
                                    <button
                                        type='button'
                                        onClick={ ()  => erasedInputs(true)}
                                        className="btn btn-secondary ms-2"
                                    >
                                        Effacer
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    )
}